import Skeleton from '@mui/material/Skeleton'
import user from 'assets/image/icons/svg/user.svg'
import clsx from 'clsx'
import * as Contacts from 'features/contacts'
import { useConversationalist } from 'features/messaging/hooks'

import css from './Participant.module.css'

export function Participant() {
	const conversationalist = useConversationalist()

	return (
		<section className={css.root}>
			<img
				alt='avatar'
				className={css.avatar}
				src={conversationalist?.pictureUrl || user}
			/>

			{conversationalist ? (
				<>
					<a
						className={css.link}
						href={`https://www.linkedin.com/in/${conversationalist.entityId}`}
						rel='noopener noreferrer'
						target='_blank'
					>
						<h2 className={css.person}>{conversationalist.fullName}</h2>
					</a>
					<p className={css.lead}>{conversationalist.occupation}</p>{' '}
				</>
			) : (
				<>
					<Skeleton className={clsx(css.link, css.person)} variant='text' />
					<Skeleton className={css.lead} variant='text' width={'15ch'} />
				</>
			)}

			<Contacts.ui.QualificationSelect
				className={css.action}
				entityId={conversationalist?.entityId}
			/>
		</section>
	)
}
